<template>
  <v-data-table
    :headers="headers"
    :items="brands"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="Brand-button-new"
          @click="$router.push({
            name: 'processing-EditBrand'
          })"
        >
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        :data-cy="`button-Brand-edit-${item.id}`"
        @click="$router.push({
          name: 'processing-EditBrand',
          query: {id: item.id}
        })"
      >
        {{ mdiPencil }}
      </v-icon>
      <v-icon
        small
        @click="remove(item)"
        color="danger"
        :data-cy="`button-Brand-remove-${item.id}`"
      >
        {{ mdiDelete }}
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiDelete, mdiPencil } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListBrand',
  module: 'Brand',
  mixins: [loading],
  data() {
    return {
      mdiDelete,
      mdiPencil,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('brands', ['brands']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: this.$$t('packType'),
          value: 'packType',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_brands();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('brands', ['LOAD_brands', 'DELETE_brand']),
    /** Delete Brand from the collection
     */
    async remove(Brand) {
      const result = await this.$confirm('Are you sure you want to delete this?');
      if (result) {
        this.isLoading = true;
        await this.DELETE_brand(Brand.id);
        this.isLoading = false;
      }
    },
  },
};
</script>

<docs>
# Brand example

'''js
<Brand />
'''
</docs>
